<template>
  <div>
    <div v-if="error">
      <server-error :error="error" />
    </div>
    <div v-if="settingsError">
      <div class="b-server-error mt-4 mx-6">
        <div class="b-server-error__icon-wrap p-4">
          <dynamic-icon icon="warning"></dynamic-icon>
        </div>
        <div class="b-server-error__text-wrap px-4">
          {{settingsError}}
          <router-link
            :to="{name: 'Settings'}"
            class="pl-1 b-server-error__link"
          >{{$t('CONTENT.settingsPage.set')}}</router-link>
        </div>
      </div>
    </div>
    <div v-if="isLoaded" data-cy="registry-contract-page">
      <div class="pt-4 pb-4 px-6 b-section__title">
        <h1>{{$tc('CONTENT.contract.contract', 2)}}</h1>
      </div>
      <Contracts></Contracts>
    </div>
  </div>
</template>

<script>
import Contracts from "../components/registry/contracts/Contracts";

export default {
  components: {
    Contracts
  },
  data() {
    return {
      error: null,
      settingsError: null,
    };
  },
  async created() {
    try {
      this.error = null;
      this.$loadingManager.addLoadingStep(1);
      const [, set] = await Promise.all([
        this.$store.dispatch("getAllCounterparties"),
        this.$store.dispatch("loadContractSettings"),
      ]);

      this.settingsError = null;
      this.checkIfSettingsNotSet(set);
      this.$loadingManager.loadingStepLoaded();
    } catch (e) {
      this.$loadingManager.hideLoadScreen();
      this.error = e;
    }
  },
  methods: {
    checkIfSettingsNotSet(set) {
      if (
        set.systemOwnerCounterpartyId === null ||
        set.currencyCode === null ||
        set.currencyCode === "" ||
        set.yearsToAddToPerpetuity === null
      ) {
        this.settingsError = this.$t("CONTENT.settingsPage.empty_settings_error");
      }
    },
    navigate(componentName) {
      this.$router.push({ name: componentName });
    },
  }
};
</script>
